<template lang="pug">
    .qr-card
      .button-close(@click="btnClose" v-if="show")
        icon-close
      img.qr-code(src="~assets/ui/qroffical.jpg")
      .copy
        .line  长按二维码
        .line  关注加州旅游局公众号

</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power2, Circ} from 'gsap'
import IconClose from 'src/components/vca/widgets/IconClose'
//import Component from '@/components/Component'

export default {
  name: "QRCard",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    IconClose
  },
  data() {
    return {
      show: false
    }
  },
  computed:{

  },
  methods: {
    init() {},
    btnClose(){
      this.$emit('close')
    }
  },
  mounted() {
    this.init()
    this.show = true
    //this.animateIn()
  },
  beforeDestroy(){

  },
  watch: {

  }
}
</script>


<style lang="sass">
    @import "src/styles/common.sass"

    .qr-card
      width: 2.5rem
      height: 2.5rem
      background: white
      border-radius: 0.1rem
      position: relative
      display: flex
      align-items: center
      justify-content: center
      flex-direction: column
      .button-close
        position: absolute
        width: 0.4rem
        height: 0.4rem
        font-size: $fs-m
        top: $ui-margin/2
        right: $ui-margin/3
        pointer-events: all
        svg
          stroke: $cl-blue !important
      .qr-code
        pointer-events: all
        display: block
        width: 45%
      .copy
        text-align: center
        margin-top: 0.15rem
        .line
          line-height: 1.2
          font-size: $fs-s
          color: $cl-blue









</style>